export const updateArray = (old, mod) => {
  return [...old, ...mod];
}
export const deleteArray = (old, mod) => {
  return old.filter(val => !mod?.includes(val.id));
}